import { render, staticRenderFns } from "./DeleteOneItem.vue?vue&type=template&id=76406a9c&"
import script from "./DeleteOneItem.vue?vue&type=script&lang=js&"
export * from "./DeleteOneItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports